import getBrowserFingerprintOrigin from 'get-browser-fingerprint';
import md5 from 'crypto-js/md5';

export async function getBrowserFingerprint(): Promise<string> {
    const fingerprint = await getBrowserFingerprintOrigin();
    const hash = md5(fingerprint.toString()).toString();
    return `pt_${hash.slice(0, 29)}`;
}
